import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import WorkCard from '@/components/feature/WorkCard';
import { workItems } from '@/mocks/works';

export default function HomeWorks() {
  const featured = workItems.slice(0, 5);

  return (
    <section className="w-full bg-background-100/70 border-y border-background-200/70 py-12 md:py-16">
      <div className="shell">
        <SectionHeading
          eyebrow="Selected Works"
          title="热门作品推荐"
          description="从奇幻公路到赛博都市，挑选近期被讨论最多的动画与漫画。鼠标悬停封面可查看详情入口。"
          actionLabel="全部作品档案"
          actionTo="/category/works"
        />

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featured.map((item) => (
            <WorkCard key={item.id} item={item} />
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 rounded-lg bg-primary-950 px-5 md:px-7 py-5">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center shrink-0">
              <i className="ri-compass-3-line text-lg"></i>
            </span>
            <div>
              <p className="text-sm text-background-50 font-medium">不知道从哪部开始？</p>
              <p className="mt-0.5 text-xs text-background-100/60">按地区、年份与知名度筛选，找到适合你的下一部。</p>
            </div>
          </div>
          <Link
            to="/category/works"
            className="inline-flex items-center justify-center gap-2 h-10 px-5 rounded-md bg-background-50 text-primary-900 text-sm hover:bg-accent-500 hover:text-primary-950 transition-colors whitespace-nowrap cursor-pointer"
          >
            进入作品库
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}